// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"link___35KSc"};